<template>
  <div class="container" style="overflow-x: hidden;">
    <HeaderComponent :menu-id="1" :show-search="true"></HeaderComponent>
    <div class="home-main">
      <div class="honme-main-btn">
        <a class="honme-main-btn-item" href="/GuQianBi">古钱币送评</a>
        <a class="honme-main-btn-item" href="/JiZhiBi">机制币送评</a>  
      </div>
      <img class="home-img" src="@/assets/image/shouye-img.png" alt="">
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      tab: "main"
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.home-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 60px;
}
// 顶部两个卡片
.card-group {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;

  .info-card {
    flex: 1;
    background: #a88e54;
    border-radius: 12px;
    text-align: center;
    padding: 48px 20px;
    color: #fff;

    h2 {
      font-size: 32px;
      font-weight: normal;
      margin: 0 0 24px;
    }

    p {
      font-size: 18px;
      line-height: 1.6;
      margin-bottom: 32px;
    }

    .card-btn {
      border: none;
      background: #fff;
      color: #333;
      padding: 8px 24px;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.home-main {
  width: 100%;
  margin-bottom: 0px;
  position: relative;
}
.honme-main-btn{
  width: 100vw;
  height: 55.2375vw;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  z-index: 1;
  .honme-main-btn-item{
    display: block;
    width: 45.5vw;
    height: 45vw;
    cursor: pointer;
    font-size: 40px;
    text-align: center;
    line-height: 42vw;
    color: #fff;
    letter-spacing: 2px;
  }
}
.home-img{
  width: 100vw;
  height: 55.2375vw;
  display: block;
}
</style>